import React from 'react'
import styled, { keyframes } from 'styled-components'

const Wrap = styled.div`
  overflow: hidden;
  white-space: nowrap;
`

const ScrollAnimation = keyframes`
  from {
    transform: translate3d(0,0,0);
  }
  to {
    transform: translate3d(-50%,0,0);
  }
`

const Scroll = styled.div`
  animation: ${ScrollAnimation} 10s linear infinite;
  white-space: nowrap;
  display: inline-block;
  user-select: none;
  pointer-events: none;
  .item {
    display: inline-block;
    margin-right: 1rem;

    .gatsby-image-wrapper {
      width: 120px;
      height: 120px;
    }
  }
  .group {
    display: inline-block;
  }
`

const Scroller = ({ children, ...rest }) => {
  return (
    <Wrap {...rest}>
      <Scroll>
        <div className="group">{children}</div>
        <div className="group">{children}</div>
      </Scroll>
    </Wrap>
  )
}

export default Scroller
